// interface ISelectOption {
//   value: string;
//   label: string;
// }

import { Button } from "@/components/UI/Button";
import {
  getHistoricDataViaRange,
  IqueryForExecutionSummaryHistorical,
} from "@/services/ActionSummaryTableSERVICES";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";

// interface ISearchParams {
//   start: Date;
//   end: Date;
//   winningCP: string;
//   size: number;
//   dealtPrice: number;
//   dealtCurrency: string;
//   numBlocks: number;
//   allocationPortfolios: string[];
// }

const HistoricalSearchSidebarContent = ({
  historicTradeDataForMainTable,
  setHistoricTradeDataForMainTable,
}: {
  historicTradeDataForMainTable: IqueryForExecutionSummaryHistorical;
  setHistoricTradeDataForMainTable: Function;
}) => {
  const { getAccessTokenSilently } = useAuth0();
  // const [selectedPortfolios] = useState<string[]>([]);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    // Write a function to check if date range is longer than 1 month.
    const data = new FormData(event.target);

    //extract form data to send to backend when ready
    const start = new Date(data.get("start") as string);
    const shortStartDate = new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(start));

    const end = new Date(data.get("end") as string);
    const shortEndDate = new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(end));

    if (shortEndDate < shortStartDate) {
      toast("End date cannot be earlier than start date");
      return;
    }

    // let winningCP = data.get("winningCP") as string;
    // let size = Number(data.get("size") as string);
    // let dealtPrice = Number(data.get("dealtPrice") as string);
    // let dealtCurrency = data.get("dealtCurrency") as string;
    // let numBlocks = Number(data.get("numBlocks") as string);
    // let allocationPortfolios = selectedPortfolios;

    // create a copy of the historicTradeDataForMainTable so the copy can be prop passed and allow the SEThistoricTradeDataForMainTable to be updated in 1 go.
    const currentHistoricalDataSettings: IqueryForExecutionSummaryHistorical = {
      ...historicTradeDataForMainTable,
    };

    currentHistoricalDataSettings.shortStartDate = shortStartDate;
    currentHistoricalDataSettings.shortEndDate = shortEndDate;

    // setHistoricTradeDataForMainTable(currentHistoricalDataSettings);

    // getHistoricDataViaRange will call the endpoint with the current data model based off the original currentHistoricalDataSettings
    getHistoricDataViaRange(
      currentHistoricalDataSettings,
      setHistoricTradeDataForMainTable,
      getAccessTokenSilently,
    );

    //Prevent default so the page does not update on submitting.
  };

  // Changing the flag on the historicTradeDataForMainTable
  function turnOffHistoricTradeDataForMainTableFlag() {
    setHistoricTradeDataForMainTable(
      (prev: IqueryForExecutionSummaryHistorical) => ({
        ...prev,
        viewingHistoricalTable: false,
      }),
      toast("Historical trade view ended"),
    );
  }

  return (
    <div
      data-testid="HistoricalSearchSidebarContentContainer"
      id="HistoricalSearchSidebarContentContainer"
      className="m-2 min-w-0 p-1"
    >
      <div>
        <div className="mb-2 pl-1">
          <div className="text-sm font-semibold text-gray-600 dark:text-gray-400">
            Historical Search
          </div>
          {/* <div data-tooltip-id="historicalSearchInfo">?</div> */}

          <Tooltip
            className="z-50 border border-white dark:bg-gray-600"
            id="historicalSearchInfo"
            place="right"
          >
            <div>Enter parameters to search for historical trades.</div>
            <div>At minimum, must enter date period that trade occurred.</div>
          </Tooltip>
        </div>
        <form
          className="flex flex-col justify-end space-y-2 pb-3"
          onSubmit={handleSubmit}
        >
          {/* Wraps so the end date stacks under the start date only when the panel is too narrow. */}
          <div className="flex flex-row flex-wrap gap-x-2 gap-y-3">
            <div>
              <label>Start Date:</label>
              <div>
                <input
                  id="datepicker-range-start"
                  name="start"
                  type="date"
                  //className={` m-5 ${theme == "dark" ? "inputCellDark" : "inputCellLight"}`}
                  className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
                  required
                />
              </div>
              <div className="pl-1 text-gray-500">dd/mm/yyyy</div>
            </div>
            <div>
              <label>End Date:</label>
              <div>
                <input
                  id="datepicker-range-end"
                  name="end"
                  type="date"
                  className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
                  placeholder="Select date end"
                  required
                />
              </div>
              <div className="pl-1 text-gray-500">dd/mm/yyyy</div>
            </div>
          </div>

          {/* <div>
          <label>Winning CP:</label>
          <div className="w-full">
            <Select
              name="winningCP"
              options={counterparties}
              styles={reactSelectCustomStylesSelectPanel(theme)}
            />
          </div>
        </div>

        <div className="flex w-full flex-col">
          <label>Size:</label>
          <input
            type="number"
            id="size"
            name="size"
            min="0"
            className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
          ></input>
        </div>
        <div className="flex w-full flex-col">
          <label className=" w-[150px] ">Dealt Price: </label>
          <input
            type="number"
            name="dealtPrice"
            min="0"
            // className="block rounded-lg p-1"
            className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
          ></input>
        </div>
        <div className="flex w-full flex-col">
          <label className=" w-[100px] ">Dealt Currency:</label>
          <input
            type="text"
            name="dealtCurrency"
            className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
          ></input>
        </div>
        <div className="flex w-full flex-col">
          <label className="">Number of Blocks:</label>
          <input
            type="number"
            name="numBlocks"
            min="1"
            className="  border border-[#D1D1D1] bg-[white] p-1 dark:border-white dark:bg-[#2D3436]"
          ></input>
        </div>
        <div>
          <label>Allocation Portfolios:</label>
          <div className=" w-full">
            <Select
              name="allocationPortfolios"
              closeMenuOnSelect={false}
              options={portfolios}
              isMulti
              styles={reactSelectCustomStylesSelectPanel(theme)}
              onChange={(e) => {
                setSelectedPortfolios(
                  e.map((option: ISelectOption) => option.value),
                );
              }}
            />
          </div>
        </div> */}
          <div className="flex w-full space-x-2">
            <Button
              type="submit"
              variant={"mainOrangeAction"}
              size={"button_sm"}
            >
              Search
            </Button>
            <Button
              type="button"
              variant={"secondaryBlueAction"}
              size={"button_sm"}
              onClick={turnOffHistoricTradeDataForMainTableFlag}
            >
              Clear Search
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HistoricalSearchSidebarContent;
